import { helpers, maxLength, required, requiredIf } from '@vuelidate/validators';
import { messageContent } from '@/common/messageContent.js';
import { commonCastDateValidations } from '@/common/commonValidations.js';

const commonCreateUpdateValidations = checkStatus => {
  return {
    onlineShopBannerData: {
      checkStatus: {
        accepted: helpers.withMessage(messageContent.requireSelect('チェックステータス'), value =>
          ['draft', 'checked', 'approved'].includes(value)
        ),
      },
      importantFlag: {
        accepted: helpers.withMessage(
          messageContent.requireSelect('優先設定'),
          value => value === true || value === false
        ),
      },
      title: {
        required: helpers.withMessage(messageContent.requireInput('タイトル'), required),
        maxlength: helpers.withMessage(
          messageContent.requireUnderMaximumNumberOfCharacters('タイトル', 30),
          maxLength(30)
        ),
      },
      contentsURL: {
        requiredIf: helpers.withMessage(
          messageContent.requireInput('URL'),
          requiredIf(() => checkStatus !== 'draft')
        ),
        maxlength: helpers.withMessage(
          messageContent.requireUnderMaximumNumberOfCharacters('URL', 500),
          maxLength(500)
        ),
      },
      imageFile: {
        binary: {
          requiredIf: helpers.withMessage(
            messageContent.requireUpload('画像'),
            requiredIf((value, vm) => {
              if (checkStatus === 'draft') return false;
              return !value && !vm.file;
            })
          ),
        },
      },
    },
  };
};

export const onlineShopBannerValidation = {
  create: checkStatus => {
    const obj = commonCreateUpdateValidations(checkStatus);

    obj.onlineShopBannerData.castStartDate = commonCastDateValidations(checkStatus).create.castStartDate;
    obj.onlineShopBannerData.castEndDate = commonCastDateValidations(checkStatus).create.castEndDate;

    return obj;
  },

  update: checkStatus => {
    const obj = commonCreateUpdateValidations(checkStatus);

    obj.onlineShopBannerData.castStartDate = commonCastDateValidations(checkStatus).update.castStartDate;
    obj.onlineShopBannerData.castEndDate = commonCastDateValidations(checkStatus).update.castEndDate;
    obj.isPublished = commonCastDateValidations(checkStatus).update.isPublished('onlineShopBannerData');
    obj.beforeCastEndDate = commonCastDateValidations(checkStatus).update.beforeCastEndDate('onlineShopBannerData');

    return obj;
  },
};
